import React, { createContext, FC, useContext } from 'react'
import { useLaneFilters } from '../hooks/useLaneFilters'

export interface ILaneFiltersContext extends ReturnType<typeof useLaneFilters> {}

export const LaneFiltersContext = createContext<ILaneFiltersContext>({
  params: {},
  queryParams: {},
  setParams: () => {},
  changeParams: () => {},
  selectedFilter: undefined,
  setSelectedFilter: () => {},
  toggleSelectedFilter: () => {},
  createToggleSelectedFilterHandler: () => () => {},
  hasStartedSearch: false,
  setHasStartedSearch: () => {},
  setQueryParams: () => {},
  clearAllFilters: () => {},
})

export const LaneFiltersProvider: FC = ({ children }) => {
  const state = useLaneFilters()
  return <LaneFiltersContext.Provider value={state}>{children}</LaneFiltersContext.Provider>
}

export const useLaneFiltersContext = () => useContext(LaneFiltersContext)
